import { StaticImageData } from 'next/image';
import RelatedArticlesBlock from './RelatedArticlesBlock'; // Import your existing component
import { H3 } from '../Element/Heading';

type ResourceProps = {
  title: string;
  href: string;
  imageSrc: StaticImageData;
};

// Parent Component to handle a list of articles
const RelatedArticlesList = ({ articles }: { articles: ResourceProps[] }) => {
  return (
    <div>
      <H3 className="text-center mb-8">Explore More on This Topic</H3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-5xl mx-auto justify-items-center mb-8">
        {articles.map((article, index) => (
          <RelatedArticlesBlock
            key={index}
            title={article.title}
            href={article.href}
            imageSrc={article.imageSrc}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedArticlesList;
